import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {ShrunkenPREditor} from './ShrunkenPREditor.jsx';
import {ErrorPopup} from './dialogs/ErrorPopup.jsx';
import {BrickContext} from 'olympe';

/**
 * @param {ExpandedPREditorFallBack.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function ExpandedPREditorFallBack(props) {
    const [showErrorPopup, setShowErrorPopup] = useState(true);

    const handleCloseErrorPopup = () => {
        setShowErrorPopup(false);
    };

    return (
        <>
            <ShrunkenPREditor
                handleClickOnExpand={props.handleClickOnExpand}
                onSave={props.handleClickOnSave}
                onSubmit={props.onSubmit}
                context={props.context}
                prTag={props.prTag}
                handleClickOnApprove={props.handleClickOnApprove}
                handleClickOnCopy={props.handleClickOnCopy}
                handleClickOnChangeLog={props.handleClickOnChangeLog}
                handleClickOnDeny={props.handleClickOnDeny}
                handleClickOnSubmitToRequester={props.handleClickOnSubmitToRequester}
                handleClickOnWithdrawn={props.handleClickOnWithdrawn}
                handleClickOnReject={props.handleClickOnReject}
                loading={props.loading}
                disabledButtons={props.disabledButtons}
                prIdFromQueryParam={props.prIdFromQueryParam}
                removePrIdFromRef={props.removePrIdFromRef}
                selectedPRs={props.selectedPRs}
                selectPRsMode={props.selectPRsMode}
                setSelectedPRs={props.setSelectedPRs}
                failedMassSubmittedPRs={props.failedMassSubmittedPRs}
                setFailedMassSubmittedPRs={props.setFailedMassSubmittedPRs}
                setSelectPRsMode={props.setSelectPRsMode}
                isAnyPRSelected={props.isAnyPRSelected}
                handleMassSubmit={props.handleMassSubmit}
                massSubmitLoading={props.massSubmitLoading}
                massDeleteLoading={props.massDeleteLoading}
                handleMassDelete={props.handleMassDelete}
                massCopyLoading={props.massCopyLoading}
                handleMassCopy={props.handleMassCopy}
                handleClickOnSupplier={props.handleClickOnSupplier}
            />
            <ErrorPopup
                onClose={handleCloseErrorPopup}
                open={showErrorPopup}
                title={`There's an issue with your Purchase Request. Please reach out to the Global IT Team.`}
                errorMessages={props.errorMessage ? [props.errorMessage] : []}
            />
        </>
    );
}

ExpandedPREditorFallBack.propTypes = {
    handleClickOnExpand: PropTypes.func,
    onSave: PropTypes.func,
    onSubmit: PropTypes.func,
    handleClickOnDeny: PropTypes.func,
    handleClickOnApprove: PropTypes.func,
    handleClickOnCopy: PropTypes.func,
    handleClickOnChangeLog: PropTypes.func,
    handleClickOnWithdrawn: PropTypes.func,
    handleClickOnSubmitToRequester: PropTypes.func,
    handleClickOnReject: PropTypes.func,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string,
    loading: PropTypes.bool,
    disabledButtons: PropTypes.object,
    selectPRsMode: PropTypes.bool,
    setSelectPRsMode: PropTypes.func,
    selectedPRs: PropTypes.array,
    setSelectedPRs: PropTypes.func,
    failedMassSubmittedPRs: PropTypes.array,
    setFailedMassSubmittedPRs: PropTypes.func,
    isAnyPRSelected: PropTypes.bool,
    handleMassSubmit: PropTypes.func,
    massSubmitLoading: PropTypes.bool,
    massDeleteLoading: PropTypes.bool,
    handleMassDelete: PropTypes.func,
    massCopyLoading: PropTypes.bool,
    handleMassCopy: PropTypes.func,
    handleClickOnSupplier: PropTypes.func,
    prIdFromQueryParam: PropTypes.string,
    removePrIdFromRef: PropTypes.func,
    handleClickOnSave: PropTypes.func,
    handleClickOnSubmit: PropTypes.func,
    errorMessage: PropTypes.string,
};
